import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Creds from "@/components/Creds";
import About from "@/components/About";
import Framework from "@/components/Framework";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Services from "@/components/Services";
import BookSection from "@/components/BookSection";
import Contact from "@/components/Contact";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Creds />
        <About />
        <Framework />
        <Marquee />
        <Story />
        <Services />
        <BookSection />
        <Contact />
      </main>
    </>
  );
}
